import React from "react";

const SummaryColumn = (props) => {
    const summary = props.summaryinfo;
    const total = props.total;
    const totalsteps = props.totalsteps;
    return(
        <div className="column">
            <div className="block-title">Summary</div>
            <ul>
                <li>
                    <span className="data-value">{total}</span>
                    <span className="data-label">Recipients</span>
                </li>
                <li>
                    <span className="data-value">{totalsteps}</span>
                    <span className="data-label">Campaign Messages</span>
                </li>
                <li>
                    <span className="data-value">{summary?.sent}</span>
                    <span className="data-label">Email sent</span>
                </li>
                <li className={(props?.messageType === 'text/plain' || !props.trackOpen) ? 'opacity-30' : ''}>
                    <span className="data-value">{summary?.open}</span>
                    <span className="data-label">Unique opens</span>
                </li>
                <li className={(props?.messageType === 'text/plain' || !props.trackClicks) ? 'opacity-30' : ''}>
                    <span className="data-value">{summary?.click}</span>
                    <span className="data-label">Unique clicks</span>
                </li>
                <li>
                    <span className="data-value">{summary?.unsubscribe}</span>
                    <span className="data-label">Unsubscribed</span>
                </li>
                
            </ul>
        </div>
    );
}

export default SummaryColumn;